var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModifica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29344 0.882466C8.57229 0.630274 8.94065 0.493265 9.32105 0.500255C9.70145 0.507245 10.0642 0.657689 10.3331 0.919947C10.602 1.1822 10.756 1.53584 10.7628 1.90647C10.7696 2.2771 10.6286 2.63585 10.3694 2.90727L3.35736 9.74083L0.5 10.5L1.27917 7.7155L8.29344 0.882466Z",
    stroke: "#2B318A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifica);
export default __webpack_public_path__ + "static/media/modifica.a9c3378e56ba62a9f8ab9870d6b78cde.svg";
export { ForwardRef as ReactComponent };